FD.Modal = (function ($, me) {
    'use strict';

    me.Modal = me.Modal || {};

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    const defaultModalOptions = {
        onShow: function () { },
        onShown: function () { },
        onHide: function () { },
        onHidden: function () { },
        options: "show",
        modal: '#FD_MODAL'
    };
    let modalLock = false;

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    function showModal(html, modalOptions, result, callbackBeforeShow, forceOpen) {
        let locked = modalLock;
        if (locked && !forceOpen) {
            return null;
        }
        modalLock = true;
        modalOptions = $.extend({}, defaultModalOptions, modalOptions);

        const $modal = $(modalOptions.modal)
            .html(html)
            .enableControls()
            .on('show.bs.modal', function () {
                if (modalOptions.onShow) {
                    modalOptions.onShow($modal, result);
                }
                $modal.off('show.bs.modal');
            })
            .on('shown.bs.modal', function () {
                if ($(".modal:visible").length > 1) {
                    $(".modal:visible").not($modal).addClass('modal-disabled');
                }
                $('[data-fd-control="textarea"]', $modal).control_textarea('resize');
                $('[autofocus]', $modal).focus();

                if (modalOptions.onShown) {
                    modalOptions.onShown($modal, result);
                }
                $modal.off('shown.bs.modal');
            })
            .on('hide.bs.modal', function () {
                $('form', $modal).dirtyForms('setClean');

                if (modalOptions.onHide) {
                    modalOptions.onHide($modal, result);
                }
                $modal.off('hide.bs.modal');
            })
            .on('hidden.bs.modal', function () {
                if ($(".modal:visible").length > 0) {
                    $(".modal:visible").not($modal).last().removeClass('modal-disabled');
                    $('body').addClass('modal-open');
                } else {
                    modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                }
                if (modalOptions.onHidden) {
                    modalOptions.onHidden($modal, result);
                }
                $modal.off('hidden.bs.modal');
            });
        if (callbackBeforeShow) {
            callbackBeforeShow(result, $modal);
        }

        if (locked && !forceOpen) {
            return $modal;
        }
        return modalOptions.options ? $modal.modal(modalOptions.options) : $modal.modal("show");
    }

    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    me.Modal.fdAjax = function (ajaxOptions, modalOptions, forceOpen) {
        if (modalLock) {
            return;
        }
        modalLock = true;

        const currentCallback = ajaxOptions.callback;
        ajaxOptions.callback = function (result) {
            if (result.data) {
                modalLock = false;
                showModal(result.data, modalOptions, result, currentCallback, forceOpen);
            } else {
                modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                if (currentCallback) {
                    currentCallback(result);
                }
            }
        };

        $.fdAjax(ajaxOptions);
    };

    me.Modal.showModal = function (html, modalOptions, forceOpen) {
        showModal(html, modalOptions, null, null, forceOpen);
    };

    me.Modal.hideModal = function () {
        if (me.Modal.isOpen()) {
            $(this).closest('.modal').modal('hide');
        }
    };

    me.Modal.isOpen = function () {
        return modalLock;
    };

    me.Modal.openModal = function (xhr) {
        me.Utility.stopLadda.call(this);
        me.Modal.showModal(xhr.responseText);
    };

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me.Modal;
}(jQuery, FD));